<template>
    <div>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t(createFormName)}}</v-toolbar-title>
            </v-toolbar>
            <!--TaskDiagram :process-instance-id="values['processInstanceId']"/-->
            <v-form id="createForm" @keyup.enter.native="onSave" v-model="formValid" lazy-validation ref="createForm">

                <v-flex background-color="red">
                    <v-tabs background-color="transparent"
                            left
                            next-icon="mdi-arrow-right-bold-box-outline"
                            prev-icon="mdi-arrow-left-bold-box-outline"
                            show-arrows
                            v-model="activeTab"
                    >
                        <v-tabs-slider color="#00ab4d"></v-tabs-slider>
                        <v-tab key="tab1" @click="refreshTabAll" style="width: 250px">
                            Thông tin khách hàng
                        </v-tab>
                        <v-tab flat color="#00ab4d" key="tab2" @click="refreshTabAll" style="width: 150px">
                            Thông tin hồ sơ
                        </v-tab>

                        <v-tab flat color="#00ab4d" key="tab3" @click="refreshTabAll" style="width: 150px">
                            File đính kèm
                        </v-tab>

                        <v-tab-item key="tab1">
                            <v-layout wrap>
                                <v-flex xs6 style="padding: 10px">


                                    <v-select :items="procedureIds" :label="$t('lang.files.procedureId')"
                                              v-model="values['procedureId']" name="procedureId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="'required'"
                                              :data-vv-as="$t('lang.files.procedureId')"
                                              :error-messages="errors.first('procedureId')"
                                              :disabled="this.values['fileId'] != undefined"
                                              v-on:input="changeProcedureId"
                                    />
                                </v-flex>
<!--                                <v-flex xs4 style="padding: 10px">-->
<!--                                    <v-select :items="countryIds" :label="$t('lang.files.registerCountryId')"-->
<!--                                              v-model="values['registerCountryId']" name="registerCountryId"-->
<!--                                              item-value="code"-->
<!--                                              item-text="name"-->
<!--                                              v-validate="''"-->
<!--                                              :data-vv-as="$t('lang.files.registerCountryId')"-->
<!--                                              :error-messages="errors.first('registerCountryId')"-->
<!--                                              :disabled="this.values['fileId'] != undefined"-->
<!--                                              v-on:input="changeRegisterCountryId"-->
<!--                                    />-->
<!--                                </v-flex>-->
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''" :label="$t('lang.files.ourFile')"
                                                  :data-vv-as="$t('lang.files.ourFile')" v-model="values['ourFile']"
                                                  name="ourFile"
                                                  :error-messages="errors.first('ourFile')" disabled></v-text-field>
                                </v-flex>

                                <v-flex xs6 style="padding: 10px">
                                    <v-select :items="customerIds" :label="$t('lang.files.customerId')"
                                              v-model="values['customerId']"
                                              name="customerId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="'required'"
                                              :data-vv-as="$t('lang.files.customerId')"
                                              :error-messages="errors.first('customerId')"
                                              v-on:input="changeCustomer"
                                    />
                                </v-flex>

                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.agentAddress')"
                                                  :data-vv-as="$t('lang.files.agentAddress')"
                                                  v-model="values['agentAddress']"
                                                  name="agentAddress"
                                                  v-if="renderComponent"
                                                  :error-messages="errors.first('agentAddress')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.contact')"
                                                  :data-vv-as="$t('lang.files.contact')"
                                                  v-model="values['contact']"
                                                  name="agentAddress"
                                                  v-if="renderComponent"
                                                  :error-messages="errors.first('contact')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="email" v-validate="'required'"
                                                  :label="$t('lang.files.email')"
                                                  :data-vv-as="$t('lang.files.email')" v-model="values['email']"
                                                  name="email"
                                                  v-if="renderComponent"
                                                  :error-messages="errors.first('email')"/>
                                </v-flex>


                                <v-flex xs6 style="padding: 10px">
                                    <v-select :items="manageIds" :label="$t('lang.files.manageId')"
                                              v-model="values['manageId']"
                                              name="manageId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="'required'"
                                              :data-vv-as="$t('lang.files.manageId')"
                                              :error-messages="errors.first('manageId')"
                                    />
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-select :items="manageIds" :label="$t('lang.files.checkId')"
                                              v-model="values['checkId']"
                                              name="checkId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="'required'"
                                              :data-vv-as="$t('lang.files.checkId')"
                                              :error-messages="errors.first('checkId')"
                                    />
                                </v-flex>
                            </v-layout>

                            <v-flex xs12 style="padding: 10px">
                                <ApplicantComponent @input="(newapplicants) => {values['applicants'] = newapplicants}"
                                                    :form-name="$t('lang.files.appliantForm')"
                                                    :default-data="values['applicants']"/>
                            </v-flex>
                            <v-flex xs12 style="padding: 10px">
                                <!--                                <PoaComponent @input="(newObject) => {values['poas'] = newObject}"-->
                                <!--                                                     :form-name="$t('lang.files.poasForm')"-->
                                <!--                                                     :default-data="values['poas']"/>-->

                            </v-flex>


                        </v-tab-item>
                        <v-tab-item key="tab2" style="background-color: white">
                            <v-layout wrap>
                                <v-flex xs2 style="padding: 10px">
                                    <div justify="center">
                                        {{$t('lang.files.sampleOfTrademark')}}
                                    </div>
                                </v-flex>
                                <v-flex xs4>
                                    <div justify="center" >
                                        <i-upload
                                                :label="$t('lang.files.sampleTrademark')"
                                                name="sampleTrademark" id="sampleTrademark"
                                                v-model="values['sampleTrademark']"
                                                file-type="sampleTrademark"
                                                multifile="false"/>
                                    </div>
                                </v-flex>

                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''"
                                                  :label="$t('lang.files.trademark')"
                                                  :data-vv-as="$t('lang.files.trademark')"
                                                  v-model="values['trademark']"
                                                  name="trademark"
                                                  :error-messages="errors.first('trademark')"/>


                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''" :label="$t('lang.files.color')"
                                                  :data-vv-as="$t('lang.files.color')"
                                                  v-model="values['color']"
                                                  name="trademark" :error-messages="errors.first('color')"/>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''" :label="$t('lang.files.yourFile')"
                                                  :data-vv-as="$t('lang.files.yourFile')" v-model="values['yourFile']"
                                                  name="yourFile" :error-messages="errors.first('yourFile')"/>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''" :label="$t('lang.files.note')"
                                                  :data-vv-as="$t('lang.files.note')" v-model="values['note']"
                                                  name="note" :error-messages="errors.first('note')"/>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''"
                                                  :label="$t('lang.files.searchPrefilling')"
                                                  :data-vv-as="$t('lang.files.searchPrefilling')"
                                                  v-model="values['searchPrefilling']"
                                                  name="searchPrefilling"
                                                  :error-messages="errors.first('searchPrefilling')"/>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''" :label="$t('lang.files.disclaimer')"
                                                  :data-vv-as="$t('lang.files.disclaimer')"
                                                  v-model="values['disclaimer']"
                                                  name="disclaimer" :error-messages="errors.first('disclaimer')"/>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <i-date-picker
                                            :label="$t('lang.files.priorityDate')"
                                            formatter="DD/MM/YYYY"
                                            v-model="values['priorityDate']"></i-date-picker>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="''" :label="$t('lang.files.priorityNo')"
                                                  :data-vv-as="$t('lang.files.priorityNo')"
                                                  v-model="values['priorityNo']"
                                                  name="priorityNo" :error-messages="errors.first('priorityNo')"/>
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-select :items="allCountryIds" :label="$t('lang.files.countryId')"
                                              v-model="values['countryId']" name="countryId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="''"
                                              :data-vv-as="$t('lang.files.countryId')"
                                              :error-messages="errors.first('countryId')"
                                    />
                                </v-flex>

                                <v-flex xs12 style="padding: 10px">
                                    <ClazzComponent @input="(newclazzs) => {values['clazzs'] = newclazzs}"
                                                    :form-name="$t('lang.files.clazzForm')"
                                                    :default-data="values['clazzs']"/>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
                        <v-tab-item key="tab3" style="background-color: white">
                            <v-layout wrap>
                                <v-flex xs6 style="padding: 10px">
                                    <v-select :items="poaIds" :label="$t('lang.files.poaId')"
                                              v-model="values['poaId']" name="poaId"
                                              item-value="id"
                                              item-text="name"
                                              v-validate="''"
                                              :data-vv-as="$t('lang.files.poaId')"
                                              :error-messages="errors.first('poaId')"
                                    />
                                </v-flex>
                                <v-flex xs6 style="padding: 10px">

                                    <i-date-picker v-if="values['poaId'] == 1"
                                            :label="$t('lang.files.poaDeadline')"
                                            formatter="DD/MM/YYYY"
                                            v-model="values['poaDeadline']"></i-date-picker>
                                    <i-upload v-else-if="values['poaId'] != undefined"
                                            :label="$t('lang.files.poaAttach')"
                                            name="poaAttachId" id="poaAttachId"
                                            v-model="values['poaAttachId']"
                                            inputType="button"
                                            multifile="true"/>

                                </v-flex>
                                <v-flex xs6 style="padding: 10px">
                                    <v-text-field append-icon="" v-validate="'required'"
                                                  :label="$t('lang.files.poaNumber')"
                                                  :data-vv-as="$t('lang.files.poaNumber')" v-model="values['poaNumber']"
                                                  name="poaNumber"
                                                  v-if="values['poaId'] == 4"
                                                  :error-messages="errors.first('poaNumber')"/>
                                </v-flex>



                                <v-flex xs12 style="padding: 10px">
                                    <FileAttachComponent @input="(newObject) => {values['fileattachs'] = newObject}"
                                                         :form-name="$t('lang.files.fileattachsForm')"
                                                         :default-data="values['fileattachs']"/>
                                </v-flex>
                            </v-layout>

                        </v-tab-item>
                    </v-tabs>
                </v-flex>


                <v-flex xs6 style="padding: 10px">
                </v-flex>


            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>

                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import IDatePicker from "../../components/form/DatePicker";
    import ApplicantComponent from "./components/ApplicantComponent";
    import ClazzComponent from "./components/ClazzComponent";
    import FileAttachComponent from "./components/FileAttachComponent";
    import IUpload from "../../components/form/Upload";
    import TaskDiagram from "../admin/task/TaskDiagram";

    export default {
        name: 'file-create',
        components: {TaskDiagram, FileAttachComponent, ClazzComponent, ApplicantComponent, IDatePicker, IUpload},
        inheritAttrs: true,
        props: {
            enableDelete: {
                type: Boolean,
                default: false
            },
            createFormName: {
                type: String,
                default: 'Create Form'
            },
            inputItems: {
                type: Array,
                default: () => []
            },
            createUrl: {
                type: String,
                default: "/files/save"
            },
            deleteUrl: {
                type: String,
                default: ""
            },
            column: {
                type: String,
                default: "12"
            },
            request:{
                type: Object,
                default: () => {
                    return null;
                }
            },

            defaultData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            searchDiv: {
                type: String,
                default: "searchDiv"
            },
            createDiv: {
                type: String,
                default: "createDiv"
            }
        },
        data: () => {
            return {
                formValid: false,
                parentData: "test",
                values: {},
                renderComponent: true,
                activeTab: 0,
                multifile: false,
                createItems: [
                    {
                        name: "manageId",
                        items: [],
                    },
                    {
                        name: "customerId",
                        items: [],
                    },
                    {
                        name: "procedureId",
                        items: [],
                    },
                    {
                        name: "countryId",
                        items: [],
                    }
                ],

                manageIds: [],
                customerIds: [],
                procedureIds: [],
                countryIds: [],
                allCountryIds:[],
                poaIds: [
                    {id: "1", name:"Không có",},
                    {id: "2", name:"POA sao",},
                    {id: "3", name:"POA gốc",},
                    {id: "4", name:"POA theo đơn",},
                ],
                model: {},
                subject: {},
                subjects: [],
                registerCountryId: "",
            }
        },
        watch: {
            defaultData: function (value) {
                this.values = this.copyValue(value);
                console.log(this.values);
            },
            applicants: function (value) {
                this.values['applicants'] = value;
            }
        },
        methods: {
            refreshTabAll: function () {

            },

            onView: function (value) {
                this.values = this.extractValueFromData(value);
                this.values['fileId'] = value['fileId'];
                this.values['isActive'] = 1;
                this.values['registerCountryId'] = this.registerCountryId;
                this.values['processInstanceId'] = value["processInstanceId"];
                this.activeTab = 0;
                this.applicants = this.values['applicants']
                this.$refs.createForm.resetValidation();

            },
            extractValueFromData: function (value) {
                let data = value.data;
                if (data != null && data != undefined) {
                    let ob2 = JSON.parse(data);
                    return this.copyValue(ob2);
                }
                return {}

            },
            copyValue: function (value) {
                let ob = {};
                for (let key in value) {
                    ob[key] = value[key];
                }
                return ob;
            },

            onSave: function () {
                this.$validator.validate().then(
                    valid => {
                        if (!valid) {
                            message.error(this.$t('lang.common.validate_fail'));
                            return;
                        }
                        this.values.data = JSON.stringify(this.values);
                        let url =process.env.VUE_APP_API_URL + this.createUrl;
                        if(this.request != null){
                            url +='?requestId='+this.request.requestId;
                        }
                        //alert(this.values.data)
                        axios.post(url, this.values).then(data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.values["fileID"]= data.id;
                                this.$emit("save", this.values);
                                this.onCancel();
                                this.reloadNumberProcedure();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        }, error => {
                            message.error(error);
                        });

                    }
                )
            },

            onCancel: function () {

                try {
                    if (document.getElementById(this.searchDiv) != null) {
                        document.getElementById(this.searchDiv).style.display = "";
                    }
                    if (document.getElementById(this.createDiv) != null) {
                        document.getElementById(this.createDiv).style.display = "none";
                    }

                    console.log(this.$parent);
                    this.$parent.onSearch();
                } catch (e) {
                    console.log(e);
                }
                this.$emit("cancel");
            }
            ,


            changeCustomer: function (customerId) {
                //alert(customerId);
                // alert(JSON.stringify(obj));
                axios.post(process.env.VUE_APP_API_URL + "/customer/search?page=0&pageSize=1", {"customerId": customerId}).then(
                    data => {
                        this.renderComponent = false;
                        this.$nextTick(() => {
                            //alert(JSON.stringify(data));
                            if (data.count > 0) {
                                //alert(JSON.stringify(data));
                                this.values['email'] = data.items[0].email;
                                this.values['contact'] = data.items[0].contact;
                                this.values['agentAddress'] = data.items[0].agentAddress;


                            } else {
                                this.values['email'] = "";
                                this.values['contact'] = "";
                                this.values['agentAddress'] = "";
                            }
                            this.renderComponent = true;
                        })

                    }
                )


            },

            changeProcedureId: function (procedureId) {
                //alert(procedureId);
                for (let i = 0; i < this.procedureIds.length; i++) {
                    if (this.procedureIds[i].id == procedureId) {
                        //alert(JSON.stringify(this.procedureIds[i]))
                        this.values['prefix'] = this.procedureIds[i].procedurePrefix;
                        this.values['currentNo'] = this.procedureIds[i].procedureNextNo;
                        this.values['subfix'] = this.procedureIds[i].procedureSubfix;
                        this.values['year'] = this.procedureIds[i].procedureYear;
                        this.values['userCodeManage'] = this.procedureIds[i].procedureUserCodeManage;
                        break;
                    }
                }

                this.generateOurFile();

            },

            changeRegisterCountryId: function () {
                this.generateOurFile();
            },

            generateOurFile: function () {
                if (this.values['registerCountryId'] != undefined && this.values['prefix'] != undefined) {
                    let subfix = "";
                    if (this.values['subfix'] != undefined) {
                        subfix = "-" + this.values['subfix'];
                    }
                    let userCodeManage = "";
                    if (this.values['userCodeManage'] != undefined) {
                        userCodeManage = "-" + this.values['userCodeManage'];
                    }
                    this.values['ourFile'] = this.values['prefix'] + this.generateCurrentNo(this.values['currentNo']) + "/"
                        + this.values['year'] + "/"
                        + this.values['registerCountryId'] + subfix + userCodeManage;


                }

            },

            generateCurrentNo: function (currentNo) {
                if (currentNo == undefined) {
                    return "";
                }
                currentNo = "" + currentNo;
                if (currentNo.length < 4) {
                    let num = 4 - currentNo.length;
                    let result = "";
                    for (let i = 0; i < num; i++) {
                        result = "0" + result;

                    }
                    return result + currentNo;
                } else {
                    return currentNo;
                }

            },

            reloadNumberProcedure: function () {
                axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/procedure", {}).then(
                    data => {
                        this.procedureIds = data.items

                    }
                )
            }


        },


        created() {
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/user", {}).then(
                data => {
                    this.manageIds = data.items;
                }
            )

            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/customer", {}).then(
                data => {

                    this.customerIds = data.items
                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/procedure", {}).then(
                data => {


                    this.procedureIds = data.items
                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/country", {}).then(
                data => {
                    this.countryIds = data.items

                }
            )

            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/allCountry", {}).then(
                data => {
                    this.allCountryIds = data.items

                }
            )
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/getUserCountry", {}).then(
                data => {
                    this.registerCountryId = data;


                }
            )
        }
    }
</script>
